import { render } from "./NimbusCalendar.vue?vue&type=template&id=85ce56d2"
import script from "./NimbusCalendar.vue?vue&type=script&lang=js"
export * from "./NimbusCalendar.vue?vue&type=script&lang=js"

import "./NimbusCalendar.vue?vue&type=style&index=0&id=85ce56d2&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__